import { Enquiry } from "@models/enquiry";
import { MatrixClass } from "@models/matrix-class";

export class EnquiriesStore {
  constructor(
    public enquiries: Enquiry[] = [],
    public activeEnquiry: Enquiry = new Enquiry(),
    public editableEnquiry: Enquiry = new Enquiry(),
    public classes: MatrixClass[] = [],
  ) {}

  static clone(store: EnquiriesStore) {
    const result = new this()

    result.enquiries        = [...store.enquiries]
    result.activeEnquiry    = store.activeEnquiry
    result.editableEnquiry  = store.editableEnquiry
    result.classes          = [...store.classes]

    return result
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/enquiries.ts